import { FadeLoader } from "react-spinners";

const LoaderComponent = ({ isInline = false }) => {
  return (
    <>
      <div className={isInline ? "loader-style-inline" : "loader-style container-fluid"}>
        <FadeLoader className="fade-loader" loading={true} color={"#D61F7F"} />
      </div>
    </>
  );
};

export default LoaderComponent;
